export { LpCollectionNewComponent } from './lp-collection-new.component';
export { LpCollectionNewHeaderComponent } from './header/header.component';
